import React,{useEffect, useState} from 'react'
import {Container, Row, Col, Button} from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import Swal from 'sweetalert2'
import { getFarms, removeFarm } from '../../../actions/farmsActions'
import { CustomDataTable } from '../../../components/design/Datatables/CustomDataTable'

export default function Farms() { 
    const { t } = useTranslation()
    const [isLoading, setIsLoading] = useState(true) 
    const {farms, loading, result} = useSelector(state=>state.farms) 
    const dispatch = useDispatch()
    
    useEffect(()=>{
        dispatch(getFarms())
    }, [dispatch])

    useEffect(()=>{
        setIsLoading(loading)
    }, [loading])

    useEffect(()=>{
        if(result != null){
            if(result !== 'ok'){
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('farms.itsok'),
                    icon: 'error',
                    text: t('farms.'+result.message+'0') + result.count + t('farms.'+result.message+'1')
                })
                dispatch({
                    type: 'FARM_RESET_RESULT'
                })
            }else{
                Swal.fire({
                    showConfirmButton: true,
                    confirmButtonText: t('farms.letsok'),
                    icon: 'success',
                    text: t('farms.deletedfarm')
                })
                dispatch({
                    type: 'FARM_RESET_RESULT'
                })
            }
        }
    }, [result, t, dispatch])

    const deleteFarm = (idFarm) => {
        Swal.fire({
            title: t('alert.areusure'),
            showDenyButton: true,
            confirmButtonText: t('alert.delete'),
            denyButtonText: t('alert.canceled'),
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(removeFarm(idFarm))
                Swal.fire(t('alert.deleted'), '', 'success')
            }
        })
    }

    // Datatables
    const columns = [
        {
            name: t('farms.name'),
            cell: datos =>
                <div>
                    {datos.name}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: t('farms.origen'),
            cell: datos =>
                <div>
                    {datos.origen?.name}
                </div>,
            selector: (datos) => datos._id,
            sortable: true,
        },{
            name: '',
            cell: datos =>
            <>
                <Button variant="outline-info mx-auto" href={`/admin/farm/`+datos._id}>
                    <i className="fas fa-map-marked"></i> <i className="fas fa-edit fa-sm"></i>
                </Button>
                <Button variant="outline-danger mx-auto" onClick={() => deleteFarm(datos._id)}>
                    <i className="fas fa-map-marked"></i> <i className="fas fa-minus fa-sm"></i>
                </Button>
            </>
        }
    ]
      
    return (
        <>
        {isLoading
        ?      
          <div className='d-flex justify-content-center vh-100'>            
              <span className="spinner-border spinner-border-sm" style={{width: "5rem",height: "5rem"}}></span>
          </div>
        : 
        <>
            <Container className='cuerpo'>
                <Row className="text-left custom-card-header-list">
                    <Col>
                        <Button className="btn btn-secondary my-2 mx-auto float-right" href={`/admin/dashboard`}>
                            <i className="fas fa-arrow-circle-left"></i> {t('global.return')}
                        </Button>
                        <h1 className='mb-2'>{t('farms.editfarm')}</h1> 
                        <label className='mb-2'>{t('farms.selectfarm')}</label>
                        <Row className="custom-card-buttom">
                            <Button className="btn btn-secondary my-2 mx-auto" href={`/admin/farm`}>
                                <i className="fas fa-map-marked"></i> {t('farms.new')}
                            </Button>
                        </Row>
                        <Row className="text-center justify-content-center">
                            {farms 
                                ?
                                    <CustomDataTable columns={columns} data={farms} />
                                :
                                    <></>
                            }
                        </Row>
                    </Col>
                </Row>
            </Container>
        </>
        }
        </>
    )
}